import { Box } from "@itandi/itandi-bb-ui";
import type React from "react";
import { StatusHandleVendorButtons } from "~/components/common/statuses/StatusHandleVendorButtons";
import { useIdQueryHandler } from "~/hooks/useIdQueryHandler";
import { useDeals } from "~/hooks/vendors/useDeals";
import { ESTIMATION_BY } from "~/models/Deal";
import { IN_ESTIMATION } from "~/models/Status";
import Styles from "./statuses.module.scss";

export const NowAccepting: React.FC = () => {
	const id = useIdQueryHandler();
	const { data: deal } = useDeals().show(id);
	if (deal === null) return null;

	return (
		<div>
			<h3 className={Styles.Title}>案件が登録されました</h3>
			<Box marginY={16}>
				<p>
					{deal.estimationBy === ESTIMATION_BY.COMPANY ? (
						<>
							管理会社によって見積作成が行われる案件です。
							<br />
							管理会社がステータスを進めるまでお待ち下さい。
							<br />
							管理会社がステータスを進めるまで、管理会社にて依頼先の変更が可能です。
						</>
					) : (
						<>
							見積作成中ステータスに変更するまで、管理会社にて依頼先の変更が可能です。
						</>
					)}
				</p>
			</Box>
			{deal.estimationBy === ESTIMATION_BY.VENDOR && (
				<StatusHandleVendorButtons
					backwardDisabled
					nextStatusId={IN_ESTIMATION}
				/>
			)}
		</div>
	);
};
